var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDataVisualization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 109,
    viewBox: "0 0 185 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1322_394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 185,
    height: 109
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 109,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1322_394)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0541 59.5545H70.0566L70.0566 59.5558C69.0803 59.5558 68.2882 58.7653 68.2891 57.7882V22.8348C68.2891 21.8585 69.0811 21.0664 70.0574 21.0664H80.055C81.0313 21.0664 81.8234 21.8585 81.8234 22.8348L81.8225 57.7861C81.8225 58.7632 81.0305 59.5545 80.0541 59.5545ZM97.1089 59.5545H87.1114C86.1351 59.5545 85.3422 58.764 85.343 57.7853V31.4102C85.343 30.4339 86.1351 29.6418 87.1114 29.6418L97.1089 29.6426C98.0853 29.6426 98.8773 30.4347 98.8773 31.411V57.7861C98.8773 58.7632 98.0853 59.5545 97.1089 59.5545ZM114.163 59.5545H104.165C103.189 59.5545 102.396 58.764 102.398 57.7852V46.4446C102.398 45.4682 103.19 44.6762 104.166 44.6762H114.164C115.14 44.6762 115.932 45.4682 115.932 46.4446L115.931 57.7861C115.931 58.7632 115.139 59.5545 114.163 59.5545Z",
    className: "secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2125 9H143.011L143.013 9.00021C144.639 9.00021 145.961 10.3236 145.961 11.9481L145.962 84.27C145.962 86.4925 142.893 87.2179 141.835 87.2179H100.059L100.702 94.1204C100.738 94.6335 101.215 98.4632 108.46 98.4632C109.437 98.4632 110.229 99.2545 110.229 100.232C110.229 101.208 109.437 102 108.46 102H75.7663C74.79 102 73.9979 101.208 73.9979 100.232C73.9979 99.2545 74.79 98.4632 75.7663 98.4632C83.0109 98.4632 83.4879 94.6335 83.5175 94.196L84.1673 87.2177H41.2125C39.5872 87.2177 38.2646 85.8959 38.2646 84.2698V11.9479C38.2646 10.3226 39.5872 9 41.2125 9ZM41.8019 68.9409H142.421V12.5375H41.8019V68.9409Z",
    className: "secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.011 9H41.2125C39.5872 9 38.2646 10.3226 38.2646 11.9479V84.2698C38.2646 85.8959 39.5872 87.2177 41.2125 87.2177H84.1673L84.1653 87.239H100.061L100.059 87.2179H141.835C142.893 87.2179 145.962 86.4925 145.962 84.27L145.961 11.9481C145.961 10.3236 144.639 9.00021 143.013 9.00021L143.011 9ZM142.421 68.9409H41.8019V12.5375H142.421V68.9409Z",
    className: "primary-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataVisualization);
export default __webpack_public_path__ + "static/media/icon-data-visualization.b303d4ab566a797b4b89908afc39bd8e.svg";
export { ForwardRef as ReactComponent };